export const LOGO_DEFAULT_NAME = 'logo.png';

export interface IWhitelabelIosFiles {
  appProvisionProfile: string | null;
  oneSignalProvisionProfile: string | null;
  certificate: string | null;
  icons: string[] | null;
  appIcon: string | null;
  googleServicePlist: string | null;
}

export interface IWhitelabelAndroidFiles {
  keytool: string | null;
  store: string | null;
  googleServiceJson: string | null;
  icons: string[] | null;
  appIcon: string | null;
}

export interface IWhitelabelOnesignalIosPropertiesConfiguration {
  bundleId: string | null;
  provisionProfileSpecifier: string | null;
}

export interface IWhitelabelOnesignalPropertiesConfiguration {
  appId: string;
  apiKey: string;
}

export interface IWhitelabelAndroidPropertiesConfiguration {
  androidPackageName: string | null;
  sha256CertificateFingerPrint: string | null;
  serviceAccountEmail: string | null;
  serviceAccountPrivateKey: string | null;
  status: number;
  files: IWhitelabelAndroidFiles | null;
}

export interface IWhitelabelDeepLinkPropertiesConfiguration {
  url: string;
  host: string;
  qrCode: string;
  qrCodeContent: string;
}

export interface IWhitelabelIosPropertiesConfiguration {
  developmentTeam: string | null;
  iosBundleId: string | null;
  applicationGroup: string | null;
  apiKeyId: string | null;
  apiKeyIssuerId: string | null;
  apiTokenBase64: string | null;
  provisionProfileSpecifier: string | null;
  status: number;
  appId: string | null;
  oneSignal: IWhitelabelOnesignalIosPropertiesConfiguration | null;
  files: IWhitelabelIosFiles | null;
  iosCertificateExpiryDate: string | null;
}

export interface IWhitelabelStylesConfiguration {
  accentColor: string | null;
}

export interface IWhitelabelVersionConfiguration {
  versionName: string;
  versionCode: string;
}

export interface IWhitelabelConfiguration {
  name: string;
  isDraft: boolean;
  intentUrl?: string;
  accountantId: string;
  intentScheme?: string;
  deepLink: IWhitelabelDeepLinkPropertiesConfiguration | null;
  oneSignal: IWhitelabelOnesignalPropertiesConfiguration | null;
  ios: IWhitelabelIosPropertiesConfiguration | null;
  android: IWhitelabelAndroidPropertiesConfiguration | null;
  styles: IWhitelabelStylesConfiguration | null;
  versions: IWhitelabelVersionConfiguration | null;
}

export interface IPendingWhitelabelConfiguration {
  accountantId: string;
  accountantName: string;
  hasAndroid: boolean;
  hasIos: boolean;
}

export class PendingWhitelabelConfiguration
  implements IPendingWhitelabelConfiguration
{
  public accountantId!: string;
  public accountantName!: string;
  public hasAndroid!: boolean;
  public hasIos!: boolean;

  public constructor(config: IPendingWhitelabelConfiguration) {
    Object.assign(this, config);
  }
}

export class WhitelabelConfiguration implements IWhitelabelConfiguration {
  public name!: string;
  public intentUrl?: string;
  public accountantId!: string;
  public isDraft!: boolean;
  public intentScheme?: string;
  public deepLink!: IWhitelabelDeepLinkPropertiesConfiguration | null;
  public oneSignal!: IWhitelabelOnesignalPropertiesConfiguration | null;
  public ios!: IWhitelabelIosPropertiesConfiguration;
  public android!: IWhitelabelAndroidPropertiesConfiguration;
  public styles!: IWhitelabelStylesConfiguration | null;
  public versions!: IWhitelabelVersionConfiguration | null;

  public constructor(config: IWhitelabelConfiguration) {
    Object.assign(this, config);
  }

  public get hasNecessaryParameterersToRunIosLogicApp() {
    return (
      !!this.hasIos() &&
      !!this.oneSignal?.appId &&
      !!this.ios.apiKeyId &&
      !!this.ios.apiKeyIssuerId &&
      !!this.ios.apiTokenBase64 &&
      !!this.ios.iosBundleId &&
      !!this.versions?.versionCode &&
      !!this.versions.versionName
    );
  }

  public get hasNecessaryParametersToRunAndroidLogicApp() {
    return (
      !!this.hasAndroid() &&
      !!this.oneSignal?.appId &&
      !!this.android.androidPackageName &&
      !!this.versions?.versionCode &&
      !!this.versions.versionName
    );
  }

  public hasIos() {
    return !!this.ios;
  }

  public hasAndroid() {
    return !!this.android;
  }

  public static toIntentUrl(intentScheme: string) {
    return `${intentScheme}://open`
  }

  public static toIntentScheme(packageName: string | null) {
    return packageName?.replace(/\./g, '');
  }
}
